export default "__VITE_ASSET__409eaa80__"